<template>
  <div class="matters_list">
    <el-form ref="baseForm" :rules="rules" :model="fromData">
      <search-box @subSearch="subSearch" :fromData="fromData">
        <el-form-item class="item" label="销售订单号：" prop="saleVoucherNo">
          <el-input v-model="fromData.searchCriteria.saleVoucherNo" placeholder="请输入销售订单号"></el-input>
        </el-form-item>
      </search-box>
    </el-form>

    <tab-list
      setHeadBtn
      :tabCheckbox="false"
      ref="actionbtn"
      tabHeight="310"
      :selectedList="selectedList"
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData"
      :columns="tabColumns"
      tabName="order-list"
      @getSelect="getSelect"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
    ></tab-list>
  </div>
</template>
<script>
import { queryOrder,CancelOrder } from "api/business.js";
import { saleOutStock } from "api/stock.js";
import tabList from "components/table/list.vue";
import { productOrder } from "api/business.js";
import searchBox from "components/common/search.vue";
export default {
  components: {
    tabList,
    searchBox
  },
  props: {
    //已选列表,未添加到数据库
    selectedList: Array
  },
  data() {
    return {
      sdata: {},
      rules: {
        saleVoucherNo: [{ message: "", trigger: "blur" }]
      },
      loading: true,
      isComponentChild: false,
      dialogFormVisible: false,
      listArr: [], //列表
      tabColumns: [
        { field: "saleVoucherNo", title: "销售订单号" },
        { field: "companyDesc", title: "公司" },
        { field: "customerDesc", title: "客户" },
        { field: "orderer", title: "联系人" },
        { field: "telephone", title: "联系电话" },
        { field: "address", title: "送货地址" },
        { field: "projectTxt", title: "备注" },
        { field: "createDate", title: "单据日期" }
      ], //表头字段
      //isDelList:false,//是否显示已删除的
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 10, //每页显示的数量,
        searchCriteria: {}
      }
    };
  },
  watch: {
    //监听选择的变化
    selectedList: {
      handler: function(newVal) {
        if (this.selectedList.length != newVal.length) {
          this.getList();
        }
      },
      deep: true
    },
    fromData: {
      handler: function() {
        console.log(11, "条件改变");
        this.getList();
      },
      deep: true
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //取消选择
    cancelSelect() {
      this.$refs.multipleTable.cancelSelect();
    },
    //获取已选
    getSelect(res) {
      this.$emit("getSelect", res);
    },
    //选中数据
    selectSdata(data) {
      console.log(data);
      this.sdata = data;
      this.$emit("selectSdata", data);
    },
    //初始化需要获取的数据
    async getList() {
      let postURL=queryOrder.list
     if(this.$store.state.cache.TypeID==200){
          postURL=CancelOrder.CanceOrderSearsh
     }
      let res = await this.$post(postURL, this.fromData); 
      if (res.msgCode === "200") {
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      } else {
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
      this.loading = false;
      this.isComponentChild = true;
      // this.$refs.multipleTable.changeTabListChecked();
    },
    //当前页码改变
    currentChange(currentPage) {
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages) {
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    //搜索按钮
    subSearch() {
      this.fromData.page = 1;
      this.getList();
    },
    handleSelectChange(item, key) {
      if (item.isLock) return false;
      if (item.isChecked) {
        item.isChecked = false;
        this.selectList.splice(key, 1);
      } else {
        item.isChecked = true;
        this.selectList.push(item);
      }
    }
  }
};
</script>

<style>
</style>
